import type { TRuleWithTheme } from '@/styles/theme';

export const optionsWrapper: TRuleWithTheme = () => ({
    marginTop: '2rem',
});

export const buttonWrapper: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'center',

    paddingTop: '1.5rem',
    marginTop: '1.25rem',

    borderTop: `1px solid ${theme.colors.lightGrey4}`,
});
